(() => {
  const openers=new WeakMap();
  let escapeClosedPanel=false;
  const fitPanel=panel=>{
    const viewport=window.visualViewport;
    const width=Math.min(document.documentElement.clientWidth,window.innerWidth,viewport?.width||window.innerWidth);
    panel.style.setProperty('--glow-category-viewport-width',`${Math.floor(width)}px`);
    panel.style.setProperty('--glow-category-viewport-height',`${Math.floor(viewport?.height||window.innerHeight)}px`);
  };
  let fitFrame=0;
  const scheduleFit=()=>{
    if(fitFrame)return;
    fitFrame=requestAnimationFrame(()=>{
      fitFrame=0;
      const panel=document.querySelector('[data-glow-category-panel][open]');
      if(panel)fitPanel(panel);
    });
  };
  window.addEventListener('resize',scheduleFit,{passive:true});
  window.visualViewport?.addEventListener('resize',scheduleFit,{passive:true});
  const pointerInput=()=>{document.documentElement.dataset.glowNavInput='pointer';};
  pointerInput();
  window.addEventListener('pointerdown',pointerInput,{capture:true,passive:true});
  window.addEventListener('touchstart',pointerInput,{capture:true,passive:true});
  window.addEventListener('keydown',event=>{
    if(event.key==='Tab'||event.key.startsWith('Arrow'))document.documentElement.dataset.glowNavInput='keyboard';
  },true);
  function init() {
    document.querySelectorAll('[data-glow-category-trigger]').forEach(trigger=>{
      if(!document.getElementById(trigger.dataset.glowCategoryTrigger))return;
      trigger.setAttribute('aria-haspopup','dialog');
      trigger.setAttribute('aria-controls',trigger.dataset.glowCategoryTrigger);
    });
    document.querySelectorAll('[data-glow-category-panel]').forEach(panel=>{
      if(panel.dataset.glowReady)return;
      panel.dataset.glowReady='true';
      panel.addEventListener('cancel',()=>{escapeClosedPanel=true;});
      panel.addEventListener('click',event=>{
        const control=event.target.closest('[data-glow-category-back],[data-glow-category-close]');
        if(control)panel.close(control.hasAttribute('data-glow-category-close')?'menu':'back');
      });
      panel.addEventListener('close',()=>{
        const trigger=openers.get(panel);
        if(!trigger?.isConnected)return;
        trigger.setAttribute('aria-expanded','false');
        const details=document.getElementById('Details-menu-drawer-container');
        if(panel.returnValue==='menu'&&details?.open){
          if(window.GlowNavigation)window.GlowNavigation.close();else details.querySelector(':scope > summary')?.click();
        }else if(details?.open&&window.GlowNavigation){
          window.GlowNavigation.focusMenu(trigger);
        }else if(details?.open&&typeof trapFocus==='function'){
          trapFocus(details,trigger);
        }else{
          trigger.focus();
        }
      });
    });
  }
  window.addEventListener('click',event=>{
    const trigger=event.target.closest('[data-glow-category-trigger]');
    if(!trigger){
      const details=document.querySelector('#Details-menu-drawer-container[open]');
      const drawer=details?.querySelector('#menu-drawer');
      if(!drawer||document.querySelector('[data-glow-category-panel][open]'))return;
      if(event.target.closest('.header'))return;
      const box=drawer.getBoundingClientRect();
      const outside=event.clientX<box.left||event.clientX>=box.right||event.clientY<box.top||event.clientY>=box.bottom;
      if(!outside)return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if(details.classList.contains('menu-opening'))details.querySelector(':scope > summary')?.click();
      return;
    }
    const panel=document.getElementById(trigger.dataset.glowCategoryTrigger);
    if(!panel||typeof panel.showModal!=='function')return;
    event.preventDefault();
    event.stopImmediatePropagation();
    openers.set(panel,trigger);
    trigger.setAttribute('aria-haspopup','dialog');
    trigger.setAttribute('aria-controls',panel.id);
    trigger.setAttribute('aria-expanded','true');
    if(typeof removeTrapFocus==='function')removeTrapFocus();
    panel.returnValue='back';
    fitPanel(panel);
    panel.showModal();
    panel.querySelector('.glow-category-panel__scroll').scrollTop=0;
  },true);
  window.addEventListener('keyup',event=>{
    if(!escapeClosedPanel||event.key!=='Escape')return;
    escapeClosedPanel=false;
    event.preventDefault();
    event.stopImmediatePropagation();
  },true);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();

